/**
 * Desvío de endpoints puntuales de `heru-fiscal-engine` (Go) hacia una
 * instancia local, mientras el servicio releva a `heru-core-invoice-service`.
 *
 * Va POR ENDPOINT y no por `VITE_LOCAL_SERVICES`, que desvía el servicio
 * COMPLETO: `fiscalEngine` lo consumen 14 call sites (perfil fiscal, buzón SAT,
 * declaraciones v3, CURP, sync status). Un Go local que solo implementa CSD y
 * timbrado responde 401 a todos ellos, y un 401 en `FetchV2` borra el token y
 * manda la app a /login: desviar el servicio entero tumba la sesión.
 *
 * Vacío en prod, que es el default: entonces `directURL` es undefined y
 * `FetchV2` resuelve contra el gateway como cualquier otro servicio. Ya NO
 * decide a qué backend va el flujo: el fiscal-engine está desplegado y es el
 * único destino. Esto solo desvía a una instancia local para desarrollar.
 */
const FISCAL_ENGINE_PATH = '/api/v1/heru-fiscal-engine';

/**
 * El fiscal-engine local firma sus JWT con otra llave que el gateway de prod,
 * así que el token de la sesión no valida contra él. `VITE_FISCAL_ENGINE_LOCAL_TOKEN`
 * lleva uno emitido por la API local. En prod ambas variables están vacías y
 * estos endpoints usan el token de la sesión como cualquier otro.
 */
export const fiscalEngineOptions = (
  endpoint: string,
  headers?: Record<string, string>,
): { directURL?: string; headers?: Record<string, string> } | undefined => {
  const base = import.meta.env.VITE_FISCAL_ENGINE_LOCAL_URL;
  if (!base) return headers ? { headers } : undefined;

  const localToken = import.meta.env.VITE_FISCAL_ENGINE_LOCAL_TOKEN;
  return {
    directURL: `${base}${FISCAL_ENGINE_PATH}${endpoint}`,
    headers: {
      ...headers,
      ...(localToken ? { Authorization: `Bearer ${localToken}` } : {}),
    },
  };
};
